module.exports = __webpack_public_path__ + "static/media/wizualizacja-66.9e07e1c7.png";